<template>
    <div class="notifiche-page">

        <div id="notifiche-output" class="step">

            <Notifications/>

        </div>

    </div>

</template>

<script>
import Notifications from '@/components/Notifications.vue'

export default {
    name: 'task-aperte',
    components: {
        Notifications,
    },
}
</script>
